import { Directive } from '@angular/core';
import { Listing } from '@df/catalog-ui/listing/listing';
import { IPageDataV2 } from '@df/catalog/cms/cms-model.interface';
import { ICmsContent, NICmsContentComponent } from '@icms/core/content';
import compact from 'lodash-es/compact';
import orderBy from 'lodash-es/orderBy';
import uniq from 'lodash-es/uniq';
import { PRIMARY_TAG_FILTER_TYPE } from '../../../../catalog/ui/listing/filter/primary-tag/filter-primary-tag';
import { CmsComponentListingAbstract } from '../../../component/listing/cms-component-listing.abstract';
import { ICmsPageDecorator } from '../../../page/icms-page.decorator';
import { NCmsBlogPost } from '../../post/cms-blog-post.interface';
import { NCmsBlogComponentListing } from './cms-blog-component-listing.interface';

@Directive()
export abstract class CmsBlogComponentListingAbstract extends CmsComponentListingAbstract implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    override component!: NCmsBlogComponentListing.IData;

    tags: string[] = [];

    get listingAsBlogPosts(): Listing<ICmsPageDecorator<IPageDataV2<NCmsBlogPost.ITypeData>>> {
        return this.listing as unknown as Listing<ICmsPageDecorator<IPageDataV2<NCmsBlogPost.ITypeData>>>;
    }

    showMore() {
        if (this.listing && this.listing.hasMore) {
            this.listing.increaseLimit();
        }

        this.detectChanges();
    }

    override getFilters() {
        return [{ type: PRIMARY_TAG_FILTER_TYPE }];
    }

    protected override getListingModelIds(models: ICmsPageDecorator<IPageDataV2>[]): number[] {
        return orderBy(models, ['data.typeData.date'], ['desc']).map((i: ICmsPageDecorator<IPageDataV2>) => i.id);
    }

    protected override onListingCreated(): void {
        this.tags = this.getTags();
        
        super.onListingCreated();
    }

    protected getTags(): string[] {
        return compact(uniq(this.listingAsBlogPosts?.getSourceModels().map(page => page.data?.typeData?.primary_tag)) || []);
    }
}
